import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-calculo-custo',
  templateUrl: './calculo-custo.component.html',
  styleUrls: ['./calculo-custo.component.css']
})
export class CalculoCustoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
